<template>
  <b-container id="navbar">
    <b-row class="nav-wrapper">
      <router-link to="/hanke">
        <b-col class="router-container">1.<br/><span class="d-none d-md-block">Aloita hankkeeseen ryhtyminen</span></b-col>
      </router-link>
      <router-link to="/puunkaytonmahdollisuus">
        <b-col class="router-container">2.<br/><span class="d-none d-md-block">Selvitä kohteen palomääräykset</span></b-col>
      </router-link>
      <router-link to="/jarjestelmat">
        <b-col class="router-container">3.<br/><span class="d-none d-md-block">Tutustu runkojärjestelmiin</span></b-col>
      </router-link>
      <router-link to="/rakennetyypit">
        <b-col class="router-container">4.<br/><span class="d-none d-md-block">Valitse kohteen rakenteet</span></b-col>
      </router-link>
      <router-link to="/kustannukset">
        <b-col class="router-container">5.<br/><span class="d-none d-md-block">Katso aikaisempia kustannuksia</span></b-col>
      </router-link>
      <router-link to="/kilpailuta">
        <b-col class="router-container">6.<br/><span class="d-none d-md-block">Löydä ratkaisuja tarjoavia yrityksiä</span></b-col>
      </router-link>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .nav-wrapper{
    flex-wrap: nowrap;
    justify-content: center;
  }
  .router-container{
    background-color: rgba(40, 80, 79, 0.8);
    padding: 1.5em 1em;
    height: 100%;
  }
  .router-link-active .router-container{
    background-color: #EBBF58;
  }
  a{
    color: #FFF;
    text-decoration: none;
  }
  .router-link-active {
    color: #0F3332;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue